import book1 from '../images/books/book-1.jpg' // ואהבת לרעך כמוך
import book2 from '../images/books/book-2.jpg' // משאלה ירוקה
import book3 from '../images/books/book-3.jpg' // כולנו בני אדם
import book4 from '../images/books/book-4.jpg' // לתת מכל הלב
import book5 from '../images/books/book-5.jpg' // נשימה
import book6 from '../images/books/book-6.jpg'// אדפ-אדמה שמים-מים ומה שבינהם
import book7 from '../images/books/book-7.jpg' // כל יום דף מחדש
import book8 from '../images/books/book-8.jpg' // שערים והרהורים

const books = [
    {
        id: 1,
        coverImage: book4,
        title: "לתת מכל הלב",
        dateReleased: "01-02-2020",
        summary: "",
        category: "children"
    },
    {
        id: 2,
        coverImage: book2,
        title: "משאלה ירוקה",
        dateReleased: "19-07-2014",
        summary: "",
        category: "children"
    },
    {
        id: 3,
        coverImage: book1,
        title: "ואהבת לרעך כמוך",
        dateReleased: "08-01-2003",
        summary: "",
        category: "children"
    },
    {
        id: 4,
        coverImage: book3,
        title: "כולנו בני אדם, שונים אך גם דומים",
        dateReleased: "09-12-1998",
        summary: "",
        category: "children"
    },
    {
        id: 5,
        coverImage: book8,
        title: "שערים והרהורים",
        dateReleased: "11-12-2007",
        summary: "",
        category: "thoughtful"
    },
    {
        id: 6,
        coverImage: book5,
        title: "נשימה.",
        dateReleased: "06-06-2008",
        summary: "",
        category: "thoughtful"
    },
    {
        id: 7,
        coverImage: book7,
        title: "כל יום דף מחדש",
        dateReleased: "01-01-2001",
        summary: "",
        category: "thoughtful"
    },
    {
        id: 8,
        coverImage: book6,
        title: "אדם-אדמה, שמים-מים ומה שבינהם.",
        dateReleased: "02-02-2002",
        summary: "",
        category: "thoughtful"
    }
]

export default books